import { type FC } from "react";
import { Col, Row } from "~/common/components/Layout";
import Parameter from "~/common/components/Parameter";
import { DateFormatType, formatNullableDate } from "~/common/utils/DateFormatter";
import { WeightFormat } from "~/domains/product/components/WeightFormat";
import { type DeliveryEntryData } from "~/domains/orders/types/models";
import { useTranslation } from "react-i18next";

interface DeliveryInformationProps {
  data: DeliveryEntryData;
  freightPayment: string;
}

const DeliveryInformation: FC<DeliveryInformationProps> = ({ data, freightPayment }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={"scha__table-pre-header scha__orders__delivery-information p-3 bg-gray mt-30"}>
        <Row>
          <Col size={12}>
            <p className={"title-medium()"}>{t("cartPage.shipmentDetails.deliveryInformation")}</p>
          </Col>
        </Row>
        <Row className={"mt-2"}>
          <Col size={2}>
            <Parameter label={t("cartPage.shipmentDetails.deliveryNumber")}>{data.deliveryNumber}</Parameter>
          </Col>
          <Col size={2}>
            <Parameter label={t("orderDetailsPage.summary.shipmentMethod")}>{t(data.shipmentPartnerID)}</Parameter>
          </Col>
          <Col size={2}>
            <Parameter label={t("cartPage.shipmentDetails.shipmentTransportNumber")}>
              {data.transportNumber || "-"}
            </Parameter>
          </Col>
          <Col size={2}>
            <Parameter label={t("cartPage.shipmentDetails.dateShipped")}>
              {formatNullableDate(data.actualGIDate, DateFormatType.DATE)}
            </Parameter>
          </Col>
          <Col size={2}>
            <Parameter label={t("cartPage.shipmentDetails.totalWeight")}>
              {data.weight.value > 0 ? <WeightFormat weight={data.weight} /> : "-"}
            </Parameter>
          </Col>
          <Col size={2}>
            <Parameter label={t("cartPage.shipmentDetails.freightPayment")}>{t(freightPayment)}</Parameter>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DeliveryInformation;
